import { configureStore as reduxConfigureStore } from '@reduxjs/toolkit';
import { setGlobalDevModeChecks } from 'reselect';

import appSettings from 'wanderu-config';
// Uses default onError (console.error). To customize, replace this import
// with createOrdersListenerMiddleware({ onError: customHandler }) and
// prepend the custom instance's .middleware instead.
import { ordersListenerMiddleware } from 'wanderu-orders';

import rootReducer from '../reducers';

function stateSanitizer(state) {
    const namespace = 'DUCKS/CARRIERS';
    const slice = 'CARRIER_DATA';
    return state && state[namespace] && state[namespace][slice]
        ? {
            ...state,
            [namespace]: {
                ...state[namespace],
                [slice]: {
                    blahblah: true,
                },
            },
        }
        : state;
}

function configureStore(initialState = {}) {
    // TODO: 'once' catches input instability on first call without per-call overhead.
    // Upgrade to 'always' once remaining selector instabilities are resolved.
    setGlobalDevModeChecks?.({
        inputStabilityCheck: 'once',
    });

    const store = reduxConfigureStore({
        devTools: shouldApplyDevTools()
            ? { stateSanitizer: stateSanitizer }
            : false,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            immutableCheck: {
                ignoredPaths: [/^(?!.*i18n|variants|experimentEligibility).*/gm],
            },
        }).prepend(ordersListenerMiddleware.middleware),
        preloadedState: initialState,
        reducer: rootReducer,
    });

    store.inject = (asyncReducerMap) => {
        Object.entries(asyncReducerMap)
            .forEach(([reducerPath, reducer]) => {
                const newReducer = rootReducer.inject( // This is not the way to do this. We should be moving reducers off of this method of injecting as we convert to slices
                    { reducer, reducerPath },
                    { overrideExisting: true },
                );
                store.replaceReducer(newReducer);
            });
    };

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', () => store.replaceReducer(rootReducer));
    }

    return store;
}

function shouldApplyDevTools() {
    const { env } = appSettings;

    if (env.isProductionBuild) {
        return false;
    }

    if (!env.isClient) {
        return false;
    }

    // eslint-disable-next-line no-underscore-dangle
    return !!window.__REDUX_DEVTOOLS_EXTENSION__;
}

export default configureStore;
